/** Traductions page Employés (FR / AR) */
export const employeesPageFr = {
  pageTitle: 'Employés',
  pageDesc: 'Création des comptes employés, permissions et sessions de travail.',
  nav: {
    workers: {
      label: 'Employés',
      title: 'Employés',
      desc: 'Ajoutez des comptes, gérez les accès et l’activation.',
    },
    sessions: {
      label: 'Sessions',
      title: 'Sessions de travail',
      desc: 'Historique des connexions et activité par employé.',
    },
  },
  workersTitle: 'Employés',
  workersDesc: 'Comptes, activation et accès aux modules',
  addWorker: 'Ajouter un employé',
  workerNamePlaceholder: "Nom de l'employé",
  add: 'Ajouter',
  workerList: 'Liste',
  colId: 'ID',
  colName: 'Nom',
  colCode: 'Code',
  colStatus: 'Statut',
  colPermissions: 'Permissions',
  colActions: 'Actions',
  statusActive: 'Actif',
  statusInactive: 'Inactif',
  permissions: 'Permissions',
  deactivate: 'Désactiver',
  activate: 'Activer',
  off: 'Off',
  on: 'On',
  workerCreated: 'Employé « {{name}} » créé — code caissier : {{code}}',
  workerCreateFailed: 'Impossible d\'enregistrer l\'employé "{{name}}". Réessayez.',
  workerCreateNoBusiness: 'Session entreprise introuvable — reconnectez-vous puis réessayez.',
  workerCreateDuplicate: 'Un employé avec ce code existe déjà. Réessayez.',
  workerActivated: 'Employé activé',
  workerDeactivated: 'Employé désactivé',
  permissionsUpdated: 'Permissions mises à jour pour {{name}}',
  permModalTitle: 'Permissions',
  close: 'Fermer',
  permActive: 'Actifs',
  permInactive: 'Inactifs',
  permCoverage: 'Couverture',
  selectAll: 'Tout sélectionner',
  deselectAll: 'Tout désélectionner',
  cancel: 'Annuler',
  confirm: 'Confirmer',
  save: 'Enregistrer',
  saveNoChanges: 'Modifiez au moins une permission pour enregistrer',
  saveCreateWorker: 'Enregistrer l’employé',
  workerCreateNoModule: 'Sélectionnez au moins un module (ex. Ventes) avant d’enregistrer.',
  workerEditNoModule: 'Au moins un module doit rester actif pour ce caissier.',
  permCount: '{{active}}/{{total}}',
  permCountTitle: '{{active}} modules sur {{total}} — cliquer pour modifier',
  sectionLoading: 'Chargement…',
  createPermTitle: 'Modules autorisés à la création',
  createPermHint:
    'Pré-sélection caissier. Seules les cases cochées sont enregistrées — ajustez avant d’ajouter.',
  createPermModules: 'Modules (navigation)',
  createPermCapabilities: 'Capacités',
  resetCreatePerm: 'Réinitialiser la pré-sélection',
  permCapHint_voidSales: 'Nécessite le module Ventes',
  permCapHint_stockWrite: 'Nécessite le module Stocks',
};

export const employeesPageAr = {
  pageTitle: 'الموظفين',
  pageDesc: 'إنشاء حسابات الموظفين والصلاحيات وجلسات العمل.',
  nav: {
    workers: {
      label: 'الموظفين',
      title: 'الموظفين',
      desc: 'إضافة الحسابات وإدارة الوصول والتفعيل.',
    },
    sessions: {
      label: 'الجلسات',
      title: 'جلسات العمل',
      desc: 'سجل الدخول والنشاط حسب الموظف.',
    },
  },
  workersTitle: 'الموظفين',
  workersDesc: 'إدارة الفريق والأذونات',
  addWorker: 'إضافة موظف',
  workerNamePlaceholder: 'اسم الموظف',
  add: 'إضافة',
  workerList: 'قائمة الموظفين',
  colId: 'المعرف',
  colName: 'الاسم',
  colCode: 'الرمز',
  colStatus: 'الحالة',
  colPermissions: 'الصلاحيات',
  colActions: 'الإجراءات',
  statusActive: 'نشط',
  statusInactive: 'غير نشط',
  permissions: 'الصلاحيات',
  deactivate: 'تعطيل',
  activate: 'تفعيل',
  off: 'تعطيل',
  on: 'تفعيل',
  workerCreated: 'تم إنشاء الموظف « {{name}} » — رمز الصندوق: {{code}}',
  workerCreateFailed: 'تعذر حفظ الموظف "{{name}}". أعد المحاولة.',
  workerCreateNoBusiness: 'جلسة المؤسسة غير موجودة — سجّل الدخول ثم أعد المحاولة.',
  workerCreateDuplicate: 'موظف بهذا الرمز موجود مسبقاً. أعد المحاولة.',
  workerActivated: 'تم تفعيل الموظف',
  workerDeactivated: 'تم إلغاء تفعيل الموظف',
  permissionsUpdated: 'تم تحديث الأذونات للموظف {{name}}',
  permModalTitle: 'الصلاحيات',
  close: 'إغلاق',
  permActive: 'مفعّل',
  permInactive: 'معطّل',
  permCoverage: 'التغطية',
  selectAll: 'تحديد الكل',
  deselectAll: 'إلغاء الكل',
  cancel: 'إلغاء',
  confirm: 'تأكيد',
  save: 'حفظ',
  saveNoChanges: 'عدّل صلاحية واحدة على الأقل للحفظ',
  saveCreateWorker: 'حفظ الموظف',
  workerCreateNoModule: 'اختر وحدة واحدة على الأقل (مثل المبيعات) قبل الحفظ.',
  workerEditNoModule: 'يجب أن تبقى وحدة واحدة على الأقل مفعّلة لهذا الكاشير.',
  permCount: '{{active}}/{{total}}',
  permCountTitle: '{{active}} وحدة من {{total}} — انقر للتعديل',
  sectionLoading: 'جاري التحميل…',
  createPermTitle: 'الوحدات المسموحة عند الإنشاء',
  createPermHint:
    'التحديد المسبق للصندوق. تُحفظ فقط الخانات المفعّلة — عدّل قبل الإضافة.',
  createPermModules: 'الوحدات (التنقّل)',
  createPermCapabilities: 'القدرات',
  resetCreatePerm: 'إعادة التحديد المسبق',
  permCapHint_voidSales: 'يتطلب وحدة المبيعات',
  permCapHint_stockWrite: 'يتطلب وحدة المخزون',
};
